import axios from "axios";
const jsonConfig = require("../Config.json");

const searchCandidateAdminAPI = async (time, searchTerms,pageNumber,pageSize) => {
    try {
        let payload_data = {
            lasttesttaken : time,
            searchdata: []
        };
        searchTerms?.forEach((term) => {
            const { field, value, operator } = term;
    
        
            payload_data.searchdata.push({
                [field]: value,
                operator: operator,
            });
        });
    
        const getallresponse = await axios.post(
            jsonConfig.apiUrl + `searchnewprofiledata?page=${pageNumber}&size=${pageSize}`,payload_data,
            {
              headers: {
                "x-functions-key": jsonConfig.key,
              },
            }
          );
        
       
        let decompressedObject;
        if (getallresponse?.data && getallresponse?.data?.compressedbase64string) {
            // Lazy load fflate only when needed
            const { unzlibSync, strFromU8 } = await import("fflate");
            
            const strData = atob(getallresponse.data.compressedbase64string);
            const charData = strData.split("").map((x) => {
                return x.charCodeAt(0);
            });
            const binData = new Uint8Array(charData);

            let apiDataUnCompressed = unzlibSync(binData);
            let apiDataUnCompressedString = strFromU8(apiDataUnCompressed);
            decompressedObject = JSON.parse(apiDataUnCompressedString);
        } 
        return Promise.resolve(decompressedObject)
    }
    catch (error) {
      console.log("Error", error);
        return Promise.reject(error)
    }
};
export default searchCandidateAdminAPI;